import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const DebtorsPage = () => {
	return (
		<AuthenticatedPageLayout>
			<DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_DEBTORS} />
		</AuthenticatedPageLayout>
	);
};
